module.exports = __webpack_public_path__ + "static/media/buy3.9bd024a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/buy/buy3.png
// module id = 1653
// module chunks = 0